export type OnboardingAufgabeOption = {
    id: string;
    translation: string;
}

export const OnboardingAufgaben: OnboardingAufgabeOption[] = [
    {id: "onboarding-recruiting", translation: 'onboarding-use-case-recruiting'},
    {id: "onboarding-sales-call", translation: 'onboarding-use-case-sales'},
    {id: "onboarding-bushotline", translation: 'onboarding-use-case-bushotline'},
    {id: "onboarding-admonition", translation: 'onboarding-use-case-admonition'},
];